
export default class HamburgerMenu {

    constructor() {
        this.settings = {
            body: document.querySelector('body'),
            el: document.querySelector('[data-block="hamburger-menu"]'),
            hamburger: document.querySelector('[data-toggle="hamburger"]'),
            wrapper: document.querySelector('.hamburger-menu-wrapper')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if (this.settings.el != null) {
            this.settings.hamburger.addEventListener('click', () => {
                this.settings.wrapper.classList.toggle('hidden');
                this.settings.body.classList.toggle('overflow');
            });
        }

    }

};

new HamburgerMenu();
